import * as moment from 'moment-timezone';

export default function buildSortingDefinitions(shiftData, lastVisibleBounds) {

    const timeLineStart = moment(lastVisibleBounds.visibleTimeStart).format();
    const timeLineEnd = moment(lastVisibleBounds.visibleTimeEnd).format();
    const timeRange = shiftData.filter((data) => {
        return moment(data.shiftEndTime).isAfter(timeLineStart) && moment(data.shiftStartTime).isBefore(timeLineEnd);
    });

    const sortingDefinitions = {
        ["None"]: {
            name: "None",
            default: false,
            sortingFunction: () => {},
            stylingFunction: group => {
                return {color: 'black'};
            },
        },
        ["HasShift"]: {
            name: "Has Shift",
            default: true,
            sortingFunction: (performer1, performer2) => {
                const sortingPerformer1 = timeRange.some(shift => shift.owner === performer1.id);
                const sortingPerformer2 = timeRange.some(shift => shift.owner === performer2.id);
                return (sortingPerformer2 - sortingPerformer1) || 0;
            },
            stylingFunction: group => {
                const hasShift = timeRange.some(shift => (shift.owner === group.id));
                return {color: hasShift ? 'black' : 'grey'};
            },
        },
    };

    return sortingDefinitions;
}
